import React from 'react';
import { CardLabel, SelectHierarchy } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { getInventoryName } from '../utils';
import useAppContext from '../../../../../context/useAppContext';
import css from '../../styles.module.css';

export default function InventorySelector({ title, onOpen = () => {}, form, inventories, onChange, isInvitations = false }) {
    const { t } = useTranslation();
    const [{ event }] = useAppContext();

    const selected = React.useMemo(() => {
        return form.inventories?.map(invt => invt.pk);
    }, [form]);

    const inventoriesOptions = React.useMemo(() => {
        if (!inventories) {
            return [];
        }
        return inventories.map(inventory => ({
            text: getInventoryName(event.isFakeSeating(), inventory, event.timezone),
            value: inventory.uuid
        }));
    }, [inventories, event]);

    const handleLabelChange = React.useCallback(
        selected => {
            if (selected.length === 0) {
                return '';
            }

            if (event.isFakeSeating()) {
                return t('attendees.addAttendees.withSeats.label-dates-selected', { count: selected.length });
            } else {
                return `${selected.length} ${
                    selected.length > 1
                        ? `${t('attendees.addAttendees.withSeats.plural')} ${t('attendees.addAttendees.selectHierarchy.selectedPlural')}`
                        : `${t('attendees.addAttendees.withSeats.singular')} ${t('attendees.addAttendees.selectHierarchy.selectedSingular')}`
                }`;
            }
        },
        [event]
    );

    return (
        <div className={css['add-attendees-rates-selecthierarchy']}>
            <CardLabel className={css['selecthierarchy']}>{title}</CardLabel>

            <SelectHierarchy
                onOpen={onOpen}
                placeholder={event.isFakeSeating() ? t('attendees.addAttendees.withSeats.selectDatesPlaceholder') : t('attendees.addAttendees.withSeats.selectPlaceholder')}
                options={inventoriesOptions}
                totalItems={inventories?.length}
                labelSelectAll={event.isFakeSeating() ? t('attendees.addAttendees.withSeats.selectAllDates') : t('attendees.addAttendees.withSeats.selectAll')}
                labelApply={t('ticket.common.action.select')}
                selected={selected}
                onChange={ids => onChange(ids)}
                onLabelSelected={!isInvitations ? handleLabelChange : null}
                multi={!isInvitations}
            />
        </div>
    );
}
